import Aside from "../Component/Aside";
import Footer from "../Component/Footer";
import FormBig from "../Component/FormBig";
import Header from "../Component/Header";

export default function FormExample() {
    return <>
        <Header />
        <Aside />
        <FormBig />
        <Footer />
    </>
}